<po-page-default>
  <app-welcome (filter)="filterChange($event)" (typePage)="changeTypePage($event)" [errorBoards]="errorBoards" (logStatus)="logStatusChange()"></app-welcome>

  
  

  
  <div class="row" style="padding: 0 14px; padding-top: 15px;" *ngIf="!showMenu">
    <div style="color: #0c9abe; width: 100%; border: 1px solid #0c9abe; padding: 9px 14px 7px 14px; border-radius: 4px;">
      
      <div style="display: flex; align-items: center; gap: 10px;">

        <ng-container *ngIf="displayShowBack">
          <po-button
            (p-click)="handleShowBack()"
            style="    --color-button-background-color-primary: var(--color-tertiary);
            --color-button-border-primary: var(--color-tertiary);
            --color-button-color-primary: #ffffff;
            --color-button-background-color-primary-hover: rgb(54, 134, 156);
            --color-button-border-primary-hover: rgb(54, 134, 156);
            --color-button-color-primary-hover: #fafeff;
            --color-button-background-color-primary-pressed: rgb(54, 134, 156);
            --color-button-border-primary-pressed: rgb(54, 134, 156);"
            p-icon="po-icon po-icon-arrow-left"
            [p-small]="true"
            p-type="primary"
            p-label="Voltar">
          </po-button>
          <div style="width: 1px; height: 24px; background-color: #0c9abe;"></div>
        </ng-container>


        <span class="po-icon po-icon-cart" *ngIf="showPage === 'vendas'"></span>
        <span class="po-icon po-icon-users" *ngIf="showPage === 'vendedores'"></span>
        <span class="po-icon po-icon-finance-secure" *ngIf="showPage === 'financeiro'"></span>
        <span class="po-icon po-icon-manufacture" *ngIf="showPage === 'industrial'"></span>
        
        <span style="font-size: 13px;"><b>Módulo {{ showPage }}</b></span>
      </div>
  
    </div>
  </div>
  


  <div class="row" id="home-menu" *ngIf="showMenu">
    <div class="po-md-3 po-lg-2 po-sm-2 po-xl-2 modulo">
      <span class="po-icon po-icon-cart"></span>
      <span style="font-size: 13px; margin-left: 5px;"><b>Módulo lojas</b></span>
    </div>
    <div class="po-md-9 po-lg-10 po-sm-10 po-xl-10 align-text-right menu-text">
      <span class="po-font-text-bold po-pl-3 po-pr-3 po-pb-1 po-pt-1 select" (click)="changeMenuSelect('gestao-loja')">Gestão loja</span>
      <span class="po-font-text-bold po-pl-3 po-pr-3 po-pb-1 po-pt-1 dont-select" (click)="changeMenuSelect('ranking-loja')">Ranking loja</span>
    </div>
  </div>
  <div *ngIf="showPage === 'vendas' && menuSelect === 'gestao-loja'">
    <app-informative [filterAccomplish]="filterValue()" (errorEmitter)="errorEmitter($event)"></app-informative>
    <div class="body-charts">
      <app-hourly-sales [filterAccomplish]="filterValue()" (errorEmitter)="errorEmitter($event)"></app-hourly-sales>
      <app-payment-methods [filterAccomplish]="filterValue()" (errorEmitter)="errorEmitter($event)"></app-payment-methods>
      <app-ranking-sellers [filterAccomplish]="filterValue()" (errorEmitter)="errorEmitter($event)"></app-ranking-sellers>
      <app-billing-value [filterAccomplish]="filterValue()" (errorEmitter)="errorEmitter($event)"></app-billing-value>
      <app-billing-day [filterAccomplish]="filterValue()" (errorEmitter)="errorEmitter($event)"></app-billing-day>
      <app-top-selling [filterAccomplish]="filterValue()"></app-top-selling>
      <div class="po-row" style="height: 20px;">
      </div>
    </div>
  </div>
  <div *ngIf="showPage === 'vendas' && menuSelect === 'ranking-loja'">
    <app-ranking-filial [filterAccomplish]="filterValue()" (errorEmitter)="errorEmitter($event)"></app-ranking-filial>
  </div>
  <div *ngIf="showPage === 'vendedores'">
    <app-informative-salers [filterAccomplish]="filterValue()" (errorEmitter)="errorEmitter($event)"></app-informative-salers>
    <app-sales-returns [filterAccomplish]="filterValue()" (errorEmitter)="errorEmitter($event)"></app-sales-returns>
    <app-best-selling [filterAccomplish]="filterValue()" (errorEmitter)="errorEmitter($event)"></app-best-selling>
    <app-average-revenue [filterAccomplish]="filterValue()" (errorEmitter)="errorEmitter($event)"></app-average-revenue>
    <app-condition-pending [filterAccomplish]="filterValue()" (errorEmitter)="errorEmitter($event)"></app-condition-pending>
    <app-conditional-conversion [filterAccomplish]="filterValue()" (errorEmitter)="errorEmitter($event)"></app-conditional-conversion>
    <app-main-customers [filterAccomplish]="filterValue()" (errorEmitter)="errorEmitter($event)"></app-main-customers>
    <app-birthdays-day [filterAccomplish]="filterValue()" (errorEmitter)="errorEmitter($event)"></app-birthdays-day>
    <app-sales-record [filterAccomplish]="filterValue()" (errorEmitter)="errorEmitter($event)"></app-sales-record>
    <app-percentage-billed [filterAccomplish]="filterValue()" (errorEmitter)="errorEmitter($event)"></app-percentage-billed>
  </div>
  <div *ngIf="showPage === 'financeiro'">
    <div class="body-charts">
      <app-financial-informative [filterAccomplish]="filterValue()"></app-financial-informative>
      <app-financial-pay-receive [filterAccomplish]="filterValue()"></app-financial-pay-receive>
      <app-financial-account-balance [filterAccomplish]="filterValue()"></app-financial-account-balance>
      <app-financial-amount-received [filterAccomplish]="filterValue()"></app-financial-amount-received>
      <app-financial-late-cards [filterAccomplish]="filterValue()"></app-financial-late-cards>
      <app-financial-open-value [filterAccomplish]="filterValue()"></app-financial-open-value>
      <app-financial-result-values [filterAccomplish]="filterValue()"></app-financial-result-values>
      <app-financial-ranking-suppliers [filterAccomplish]="filterValue()"></app-financial-ranking-suppliers>
      <app-financial-ranking-clients [filterAccomplish]="filterValue()"></app-financial-ranking-clients>
      <div class="po-row" style="height: 20px;">
      </div>
    </div>
  </div>
  <div *ngIf="showPage === 'industrial'">
    <div class="body-charts">
      <app-informative-defect [filterAccomplish]="filterValue()" (errorEmitter)="errorEmitter($event)"></app-informative-defect>
      <app-finaly-order-class-day [filterAccomplish]="filterValue()" (errorEmitter)="errorEmitter($event)"></app-finaly-order-class-day>
      <app-finaly-defect-order-class-day [filterAccomplish]="filterValue()" (errorEmitter)="errorEmitter($event)"></app-finaly-defect-order-class-day>
      <app-finaly-order-total15-days [filterAccomplish]="filterValue()" (errorEmitter)="errorEmitter($event)"></app-finaly-order-total15-days>
      <app-throughput-order-place [filterAccomplish]="filterValue()" (errorEmitter)="errorEmitter($event)"></app-throughput-order-place>
      <app-quantity-order-class-location [filterAccomplish]="filterValue()" (errorEmitter)="errorEmitter($event)"></app-quantity-order-class-location>
      <app-quantity-order-class-location-part [filterAccomplish]="filterValue()" (errorEmitter)="errorEmitter($event)"></app-quantity-order-class-location-part>
      <div class="po-row" style="height: 20px;">
      </div>
    </div>
  </div>
</po-page-default>
